import React, { useState, useEffect } from 'react';
import api from '../../../services/api';

function PartnerProfileTab({ partner }) {
  const [stats, setStats] = useState({
    actionConfigsCount: 0,
    actionsCount: 0,
    flowConfigsCount: 0,
    flowsCount: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (partner) {
      fetchStats();
    }
  }, [partner]);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const response = await api.getPartnerStats(partner._id);
      setStats(response.data.stats);
    } catch (err) {
      console.error('Error fetching partner stats:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading statistics...</div>;
  }

  return (
    <div>
      <h2 style={{ marginTop: 0, marginBottom: '20px', fontSize: '20px' }}>
        Partner Profile
      </h2>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '30px'
      }}>
        {/* Action Configs Card */}
        <div style={{
          padding: '20px',
          backgroundColor: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }}>
          <div style={{
            fontSize: '14px',
            color: '#6b7280',
            marginBottom: '8px',
            fontWeight: '500'
          }}>
            Action Configurations
          </div>
          <div style={{
            fontSize: '32px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '4px'
          }}>
            {stats.actionConfigsCount}
          </div>
          <div style={{
            fontSize: '12px',
            color: '#9ca3af'
          }}>
            Total Actions: {stats.actionsCount}
          </div>
        </div>

        {/* Flow Configs Card */}
        <div style={{
          padding: '20px',
          backgroundColor: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }}>
          <div style={{
            fontSize: '14px',
            color: '#6b7280',
            marginBottom: '8px',
            fontWeight: '500'
          }}>
            Flow Configurations
          </div>
          <div style={{
            fontSize: '32px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '4px'
          }}>
            {stats.flowConfigsCount}
          </div>
          <div style={{
            fontSize: '12px',
            color: '#9ca3af'
          }}>
            Active Flows: {stats.flowsCount}
          </div>
        </div>
      </div>

      {/* Partner Details */}
      <h3 style={{ marginTop: '30px', marginBottom: '15px', fontSize: '18px' }}>
        Details
      </h3>
      
      <div style={{
        backgroundColor: '#f9fafb',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: '20px'
      }}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontSize: '14px', color: '#6b7280', display: 'block', marginBottom: '5px' }}>
            Partner Key
          </label>
          <div style={{ fontSize: '16px', fontFamily: 'monospace', color: '#111827' }}>
            {partner.partnerKey}
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontSize: '14px', color: '#6b7280', display: 'block', marginBottom: '5px' }}>
            Display Name
          </label>
          <div style={{ fontSize: '16px', color: '#111827' }}>
            {partner.displayName}
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontSize: '14px', color: '#6b7280', display: 'block', marginBottom: '5px' }}>
            Status
          </label>
          <span style={{
            display: 'inline-block',
            padding: '4px 12px',
            borderRadius: '100px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: partner.isActive ? '#dcfce7' : '#fee2e2',
            color: partner.isActive ? '#166534' : '#dc2626'
          }}>
            {partner.isActive ? 'Active' : 'Inactive'}
          </span>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontSize: '14px', color: '#6b7280', display: 'block', marginBottom: '5px' }}>
            JWT Algorithm
          </label>
          <div style={{ fontSize: '16px', color: '#111827' }}>
            {partner.jwtAlgorithm || 'HS256'}
          </div>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ fontSize: '14px', color: '#6b7280', display: 'block', marginBottom: '5px' }}>
            Created
          </label>
          <div style={{ fontSize: '16px', color: '#111827' }}>
            {new Date(partner.createdAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </div>
        </div>

        <div>
          <label style={{ fontSize: '14px', color: '#6b7280', display: 'block', marginBottom: '5px' }}>
            Last Updated
          </label>
          <div style={{ fontSize: '16px', color: '#111827' }}>
            {new Date(partner.updatedAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerProfileTab;
